<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "SelectedPeriod",
  components: { vSelect },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  methods: {
    handleChange(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<template>
  <div class="row align-items-center mb-4">
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <label for="periodSelect" class="form-label me-3 mb-0 fw-semibold">
          Period:
        </label>

        <v-select
          id="periodSelect"
          :options="options"
          :value="options.find((o) => o.value === value) || null"
          :reduce="(option) => option.value"
          label="text"
          placeholder="-- Select a period --"
          :clearable="false"
          class="flex-grow-1"
          @input="handleChange"
        />
      </div>
    </div>
    <div class="col-md-8 d-flex justify-content-end">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
